<div class="dialog-root">
  <div class="modal-overlay" *ngIf="loading">
    <mat-spinner [diameter]="56"></mat-spinner>
  </div>

  <mat-card-header>
    <mat-card-title>
      {{ isEdition ? 'Edição de Médico' : 'Cadastro de Médico' }}
    </mat-card-title>
  </mat-card-header>

  <form [formGroup]="form" class="form-grid">
    <div class="row row-1">
      <mat-form-field appearance="outline">
        <mat-label>CPF</mat-label>
        <input
          matInput
          formControlName="cpf"
          [specialCharacters]="['/', '.', '-']"
          [mask]="'000.000.000-00'"
          [disabled]="isEdition"
          (change)="onChangeCPF()"
          required
        />
        <mat-error *ngIf="form.get('cpf')?.hasError('required') && form.get('cpf')?.touched">CPF é obrigatório</mat-error>
        <mat-error *ngIf="form.get('cpf')?.hasError('invalid') && form.get('cpf')?.touched">CPF inválido</mat-error>
        <mat-error *ngIf="form.get('cpf')?.hasError('alreadyExist') && form.get('cpf')?.touched">Médico já cadastrado</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Nome</mat-label>
        <input matInput formControlName="name" required />
        <mat-error *ngIf="form.get('name')?.hasError('required') && form.get('name')?.touched">Nome é obrigatório</mat-error>
        <mat-error *ngIf="form.get('name')?.hasError('minlength') && form.get('name')?.touched">Nome muito curto</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Nascimento</mat-label>
        <input matInput type="text" formControlName="birthDate" [specialCharacters]="['/']" [mask]="'00/00/0000'" />
        <mat-error *ngIf="form.get('birthDate')?.errors?.['invalidFormat']">Formato deve ser DD/MM/AAAA</mat-error>
        <mat-error *ngIf="form.get('birthDate')?.errors?.['futureDate']">Data futura não permitida</mat-error>
        <mat-error *ngIf="form.get('birthDate')?.errors?.['underage']">Menor de 18 anos</mat-error>
      </mat-form-field>
    </div>

    <div class="row row-2">
      <mat-form-field appearance="outline">
        <mat-label>Email</mat-label>
        <input matInput formControlName="email" required (change)="onChangeEmail()" />
        <mat-error *ngIf="form.get('email')?.hasError('email') || form.get('email')?.hasError('invalid')">E-mail inválido</mat-error>
        <mat-error *ngIf="form.get('email')?.hasError('required') && form.get('email')?.touched">E-mail é obrigatório</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Celular</mat-label>
        <input matInput formControlName="mobilePhone" [specialCharacters]="['-', '(', ')', ' ']" [mask]="'(00) 00000-0000'" required />
        <mat-error *ngIf="form.get('mobilePhone')?.hasError('required') && form.get('mobilePhone')?.touched">Celular é obrigatório</mat-error>
        <mat-error *ngIf="form.get('mobilePhone')?.hasError('invalidPhone') && form.get('mobilePhone')?.touched">Número inválido</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Especialidades</mat-label>
        <mat-select multiple formControlName="specialtyIds" [compareWith]="compareById">
          <mat-option *ngFor="let item of specialties" [value]="item.id">{{ item.name }}</mat-option>
        </mat-select>
        <mat-error *ngIf="form.get('specialtyIds')?.hasError('required')">Selecione pelo menos uma especialidade</mat-error>
      </mat-form-field>
    </div>

    <div class="row row-3">
      <mat-form-field appearance="outline">
        <mat-label>CEP</mat-label>
        <input matInput formControlName="addressPostalCode" [mask]="'00000-000'" required />
        <mat-error *ngIf="form.get('addressPostalCode')?.hasError('required') && form.get('addressPostalCode')?.touched">CEP é obrigatório</mat-error>
        <mat-error *ngIf="form.get('addressPostalCode')?.hasError('invalidCep')">CEP inválido</mat-error>
      </mat-form-field>

      <span matTooltip="Preencha um CEP válido para desbloquear" [matTooltipDisabled]="cepValid" matTooltipPosition="above">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Rua</mat-label>
          <input matInput formControlName="addressStreet" required />
          <mat-error *ngIf="form.get('addressStreet')?.hasError('required') && form.get('addressStreet')?.touched">Rua é obrigatória</mat-error>
        </mat-form-field>
      </span>

      <span matTooltip="Preencha um CEP válido para desbloquear" [matTooltipDisabled]="cepValid" matTooltipPosition="above">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Bairro</mat-label>
          <input matInput formControlName="addressProvince" required />
          <mat-error *ngIf="form.get('addressProvince')?.hasError('required') && form.get('addressProvince')?.touched">Bairro é obrigatório</mat-error>
        </mat-form-field>
      </span>

      <span matTooltip="Preencha um CEP válido para desbloquear" [matTooltipDisabled]="cepValid" matTooltipPosition="above">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Número</mat-label>
          <input matInput formControlName="addressNumber" required />
          <mat-error *ngIf="form.get('addressNumber')?.hasError('required') && form.get('addressNumber')?.touched">Número é obrigatório</mat-error>
        </mat-form-field>
      </span>
    </div>

    <div class="action-buttons">
      <button mat-flat-button color="warn" class="btn-cancel" mat-dialog-close>Cancelar</button>

      <span matTooltip="{{ missingTooltip }}" [matTooltipDisabled]="!missingTooltip" matTooltipClass="tooltip-error" matTooltipPosition="above">
        <button mat-flat-button class="btn-save" [disabled]="loading || form.invalid" (click)="saveDoctor()">Salvar</button>
      </span>
    </div>
  </form>
</div>
